import { render, staticRenderFns } from "./PolyalleleSearch.vue?vue&type=template&id=52cc845e&scoped=true"
import script from "./PolyalleleSearch.vue?vue&type=script&lang=js"
export * from "./PolyalleleSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cc845e",
  null
  
)

export default component.exports